/**
 * Utilidades para el manejo de fechas en SubiGol.
 * Las fechas guardadas en la base de datos están en huso horario de Bolivia (BOT, UTC-4).
 */

/**
 * Parsea una cadena de fecha naíve de la base de datos (en horario de Bolivia)
 * a un objeto Date de JavaScript con el desplazamiento correcto de UTC-4.
 * 
 * @param {string} dateStr Fecha en formato "YYYY-MM-DD HH:MM:SS" o similar
 * @returns {Date} Objeto Date de JavaScript
 */
export function parseBoliviaDate(dateStr) {
  if (!dateStr) return new Date()
  
  // Normalizar el formato a estándar ISO
  let formattedStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T')
  
  // Si ya tiene especificado una zona horaria (ej. Z o +00:00 o -04:00), lo parseamos directamente
  if (formattedStr.includes('-') && formattedStr.lastIndexOf('-') > 7) {
    return new Date(formattedStr)
  }
  if (formattedStr.includes('+') || formattedStr.endsWith('Z')) {
    return new Date(formattedStr)
  }
  
  // De lo contrario, asumimos que viene de la base de datos en Horario de Bolivia (UTC-4)
  return new Date(formattedStr + '-04:00')
}
